import { render, staticRenderFns } from "./MenuItem.vue?vue&type=template&id=7c52d853&scoped=true&"
import script from "./MenuItem.vue?vue&type=script&lang=js&"
export * from "./MenuItem.vue?vue&type=script&lang=js&"
import style0 from "./MenuItem.vue?vue&type=style&index=0&id=7c52d853&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c52d853",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3358805848/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c52d853')) {
      api.createRecord('7c52d853', component.options)
    } else {
      api.reload('7c52d853', component.options)
    }
    module.hot.accept("./MenuItem.vue?vue&type=template&id=7c52d853&scoped=true&", function () {
      api.rerender('7c52d853', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/NewUI/containers/core/leftNavBar/MenuItem.vue"
export default component.exports